var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-15 -12 75 75",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M27 15H39c4 0 6 2 6 6V36c0 3-3 9-7 9H25c-4 0-7-3-7-7V4c0-1 0-4 4-4h1c4 0 4 3 4 4V15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M12 15H6c-4 0-6 2-6 6V39c0 4 2 6 6 6h6V15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon--like.53cfea9bc56eb471f209b654b07bf8ee.svg";
export { ForwardRef as ReactComponent };